<!-- Main Container -->
<div class="card small-card">
  <!-- Header -->
  <div class="px-4 py-2 border-b border-gray-200 dark:border-gray-700">
    <h3 class="text-lg font-semibold text-gray-800 dark:text-gray-100">
      Login Images
    </h3>
  </div>

  <!-- Card Body -->
  <div class="p-4">
    <div>
      Select an Image:
      <kendo-dropdownlist [data]="logoFileData" textField="logoFileName" valueField="logoFileName"
        [(ngModel)]="selectedLogo"></kendo-dropdownlist>
    </div>
    <div>
      Selected Image:
      <br />
      <img *ngIf="!selectedLogo" [src]="assetsPath + 'BBF_75.gif'" />
      <img *ngIf="selectedLogo" [src]="selectedLogo.imageSource" />
    </div>
  </div>
  <button primary="true" look="outline" kendoButton (click)="updateLoginLogo()">
    Set Login Image
  </button>
</div>